import React, { ReactNode } from 'react'
import { useCountries } from 'hooks/use-countries'
import Avatar from 'components/profile/Avatar'
import styles from './styles/search-results-mobile.module.scss'
import { Flag } from 'components/generic/Country'
import i18n from 'constants/strings'
import { formatAddress, getAgeReference, getProfileUrl } from 'utils'
import WatchlistToggle from 'components/watchlist/WatchlistToggle'
import { Player } from 'types/global'
import classNames from 'classnames'
import RatingWithConfidenceTick from 'components/generic/RatingWithConfidenceTick'

interface Props {
  player: Player
  withWatchlistBadge?: boolean
  children?: ReactNode
  className?: string
}

const SearchResultMobile = ({
  children,
  player,
  withWatchlistBadge = false,
  className = '',
}: Props) => {
  const {
    id,
    fullName,
    gender,
    age,
    birthYear,
    countryCode,
    avatar,
    wtnDoubles,
    wtnSingles,
    wtnConfidenceSingles,
    wtnConfidenceDoubles,
    location,
  } = player || {}
  const { getCountryName } = useCountries()
  const ageReference = getAgeReference(age, birthYear)
  const mainDetails = `${gender}, ${ageReference}`
  const locationDetails = location?.main && formatAddress(location.main)

  return (
    <article className={classNames(styles.tableMobile, className)} key={id}>
      <section className={styles.playerDetailsContainer}>
        <div className={styles.avatarContainer}>
          <Avatar url={avatar} />
        </div>
        <div className={styles.details}>
          <a href={getProfileUrl(id)} className={styles.name}>
            <h3>{fullName}</h3>{' '}
          </a>
          <p className={styles.small}>{mainDetails}</p>

          {locationDetails && <p className={styles.small}>{locationDetails}</p>}

          <p className={styles.small}>
            <Flag alpha3={countryCode} />
            <span>{getCountryName(countryCode)}</span>
          </p>
        </div>
        {withWatchlistBadge && (
          <div>
            <WatchlistToggle player={player} />
          </div>
        )}
      </section>
      <section className={styles.ratingsContainer}>
        <dl>
          <dt className={styles.ratingTitle}>{i18n.t('searchResults.singlesHeading')}</dt>
          <dd className={styles.rating}>
            <RatingWithConfidenceTick rating={wtnSingles} confidence={wtnConfidenceSingles} />
          </dd>
        </dl>
        <dl>
          <dt className={styles.ratingTitle}>{i18n.t('searchResults.doublesHeading')}</dt>
          <dd className={styles.rating}>
            <RatingWithConfidenceTick rating={wtnDoubles} confidence={wtnConfidenceDoubles} />
          </dd>
        </dl>
      </section>
      {children && <section className={styles.bottomContainer}>{children}</section>}
    </article>
  )
}

export default SearchResultMobile
